import React from 'react';

import { Box, Row } from '@opendoor/atoms/box';
import { cn } from '@opendoor/atoms/utils';

const VISIBLE_DOTS = 5;

interface CarouselDotsProps {
  length: number;
  currentIndex: number;
}

/**
 * Pagination dots for the photo carousel. The active dot widens to a pill; up
 * to five dots are visible, windowed around the current index. Width/opacity
 * animate via a CSS transition (replaces the bricks-next `Animated` dots).
 */
export const CarouselDots: React.FC<CarouselDotsProps> = ({ length, currentIndex }) => {
  const start = Math.max(0, Math.min(currentIndex - 2, length - VISIBLE_DOTS));
  const end = Math.min(start + VISIBLE_DOTS, length);
  const indices = Array.from({ length: end - start }, (_, i) => start + i);

  return (
    <Row className="items-center justify-center gap-1.5">
      {indices.map((i) => (
        <Box
          key={i}
          className={cn(
            'h-1 rounded-full bg-white transition-all duration-300',
            i === currentIndex ? 'w-4 opacity-100' : 'w-1 opacity-50',
          )}
        />
      ))}
    </Row>
  );
};
